<template>
  <v-dialog v-model="dialog">
    <v-card>
      <v-sheet class="pa-4 primary lighten-2">
        <v-text-field
          v-model="search"
          label="Поиск"
          dark
          flat
          solo-inverted
          hide-details
          clearable
          clear-icon="mdi-close-circle-outline"
        ></v-text-field>
      </v-sheet>
      <v-card-text>
        <v-treeview
          :items="items"
          active-class="grey blue--text"
          :open="opened"
          item-key="OKPD_ID"
          item-text="OKPD_NAME"
          activatable
          dense
          open-on-click
          @update:active="onNodeSelected"
          return-object
        >
        </v-treeview>
        <v-divider></v-divider>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="onCloseDialog"> Закрыть </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { USER_GET_OKPD } from '@/store/actions/user'
import { UI_SNACKBAR } from '@/store/actions/ui'

export default {
  name: 'selectFuelTypeDialog',
  model: {
    prop: 'selected',
    event: 'change'
  },
  props: {
    dialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      search: null,
      opened: [],
      selectedNode: null
    }
  },
  methods: {
    getOKPDItems () {
      this.$store.dispatch(USER_GET_OKPD)
        .catch((err) => {
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: err })
          console.log('Ошибка получения справочника ', err)
        })
    },
    convNode (node) {
      const codeArray = node.POKPD_ID.split('.')
      const retNode = { ...node }
      if (!Object.hasOwn(retNode, 'children')) {
        retNode.children = []
      }
      if (codeArray[2].length === 1) {
        retNode.POKPD_ID = null
      }
      return retNode
    },
    getTree (list) {
      const map = {}
      let node
      const roots = []
      let i

      for (i = 0; i < list.length; i += 1) {
        map[list[i].OKPD_ID] = i // initialize the map
        list[i].children = [] // initialize the children
      }

      for (i = 0; i < list.length; i += 1) {
        node = this.convNode(list[i])
        if (node.POKPD_ID) {
          // if you have dangling branches check that map[node.parentId] exists
          if (typeof map[node.POKPD_ID] !== 'undefined') {
            list[map[node.POKPD_ID]].children.push(node)
          } else {
            roots.push(node)
          }
        } else {
          roots.push(node)
        }
      }
      return roots
    },
    onNodeSelected (nodes) {
      if (nodes.length) {
        this.selectedNode = nodes[0]
        this.$emit('onSelectFT', this.selectedNode)
      } else {
        this.selectedNode = null
      }
    },
    onCloseDialog () {
      this.$emit('onCloseDialog', this.selectedNode)
    },
    searchValidator (node) {
      const nameFound = node.OKPD_NAME.toLowerCase().indexOf(this.search) >= 0
      const idFound = node.OKPD_ID.indexOf(this.search) >= 0
      return nameFound || idFound
    }
  },
  computed: {
    items () {
      const base = this.$store.getters.getOKPD
      const fltBase = this.search ? base.filter(this.searchValidator) : base
      return this.getTree(fltBase)
    }
  },
  mounted () {
    console.log('selectFuelTypeDialog component mounted')
    this.getOKPDItems()
  },
  destroyed () {
    console.log('selectFuelTypeDialog component destroyed')
  }
}
</script>

<style scoped>

</style>
